import type { Environment } from "./Environment"

export type FeatureToggle =
	| "integrated-dealer-contact-details-settings"
	| "inventory-price-service-enabled"
	| "market-export-enabled"
	| "notification-email-enabled"
	| "notification-embedded-vehicle-data"
	| "offbrand-media-edit-enabled"
	| "porsche-approved-delivery-bff-integration"
	| "porsche-approved-delivery-downtime-announcement-enabled"
	| "pwa-installable-enabled"
	| "reservation-notes-enabled"
	| "smart-search"
	| "news-enabled"
	| "syp-purchase-request-analytics"
	| "syp-purchase-request-touchpoint"
	| "video-platform-enabled"

export const environmentFeatureToggles: Record<FeatureToggle, Environment[]> = {
	"offbrand-media-edit-enabled": [],
	"porsche-approved-delivery-downtime-announcement-enabled": [],
	"smart-search": [],

	// Dev
	"integrated-dealer-contact-details-settings": ["dev"],
	"news-enabled": ["dev"],
	"pwa-installable-enabled": ["dev"],

	// Preview
	"inventory-price-service-enabled": ["dev", "preview"],
	"market-export-enabled": ["dev", "preview", "prod"],
	"notification-email-enabled": ["dev", "preview"],
	"reservation-notes-enabled": ["dev", "preview"],
	"video-platform-enabled": ["dev", "preview"],

	// Prod
	"notification-embedded-vehicle-data": ["dev", "preview", "prod"],
	"porsche-approved-delivery-bff-integration": ["dev", "prod"],
	"syp-purchase-request-analytics": ["dev", "preview", "prod"],
	"syp-purchase-request-touchpoint": ["dev", "preview", "prod"],
}
